export default "__VITE_ASSET__DVt7RLnq__"